import { render, staticRenderFns } from "./LandingDownload.vue?vue&type=template&id=b36e6ae6&scoped=true"
import script from "./LandingDownload.vue?vue&type=script&lang=js"
export * from "./LandingDownload.vue?vue&type=script&lang=js"
import style0 from "./LandingDownload.vue?vue&type=style&index=0&id=b36e6ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36e6ae6",
  null
  
)

export default component.exports